/**
 * Shared presentational constants for the Spatial Analysis UI: the brand orange,
 * the throb keyframes, and the per-step phase icons. Kept in this tiny leaf module
 * (no service/report imports) so both the heavyweight drawer AND the always-mounted
 * map sidebar rail can use them without the rail dragging the report-service /
 * saved-reports import graph onto its critical path.
 */

import React from 'react';
import { keyframes } from '@mui/material/styles';

import CropFreeIcon from '@mui/icons-material/CropFree';
import DepartureBoardIcon from '@mui/icons-material/DepartureBoard';
import DescriptionIcon from '@mui/icons-material/Description';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import GroupsIcon from '@mui/icons-material/Groups';
import HubIcon from '@mui/icons-material/Hub';
import PlaceIcon from '@mui/icons-material/Place';
import PublicIcon from '@mui/icons-material/Public';
import TableChartIcon from '@mui/icons-material/TableChart';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export const LIFTANGO_ORANGE = '#ef7335';

export const throb = keyframes`
  0%, 100% { opacity: 0.55; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.18); }
`;

/** Step id -> phase icon, shared by the drawer timeline and the sidebar rail. */
export const STEP_ICON: Record<string, React.ReactNode> = {
  study_area: <CropFreeIcon fontSize="small" />,
  context: <PlaceIcon fontSize="small" />,
  population: <GroupsIcon fontSize="small" />,
  worldpop_population: <PublicIcon fontSize="small" />,
  census_enrichment: <TableChartIcon fontSize="small" />,
  transit: <DirectionsBusIcon fontSize="small" />,
  gap: <WarningAmberIcon fontSize="small" />,
  transit_desert: <DepartureBoardIcon fontSize="small" />,
  drt_zones: <HubIcon fontSize="small" />,
  report: <DescriptionIcon fontSize="small" />,
};
